export default __webpack_public_path__ + "static/media/EditAddressIcon.97eb1732.svg";